import moment from "moment"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import {
  HAS_LOCAL_STORAGE,
  setItem,
  getItem,
} from "@kiwicom/frontend-common/browser/utils/localStorage"

type UtmSet = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  utm_source?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  utm_medium?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  utm_term?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  utm_content?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  utm_campaign?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  mkt_route?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  mkt_postback?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  mkt_origin?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  mkt_form?: string
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  mkt_agency?: string
}

const UTM_LIST: (keyof UtmSet)[] = [
  "utm_source",
  "utm_medium",
  "utm_term",
  "utm_content",
  "utm_campaign",
  "mkt_route",
  "mkt_postback",
  "mkt_origin",
  "mkt_form",
  "mkt_agency",
]

// BE limits the length of the values to 200
const UTM_VALUE_LENGTH_LIMIT = 200

export const isFresh = (item: { value: string; createdAt: Date }): boolean => {
  const date = new Date(item.createdAt)
  return moment().subtract(1, "months").isBefore(date)
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loadFromSession(cuckoo: any): UtmSet {
  if (HAS_LOCAL_STORAGE) {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return UTM_LIST.reduce<Record<string, any>>((acc: UtmSet, key: keyof UtmSet) => {
      try {
        const rawItem = getItem(key)
        if (rawItem) {
          const item = JSON.parse(rawItem)
          if (item && isFresh(item)) {
            return {
              ...acc,
              [key as string]: item.value?.substring(0, UTM_VALUE_LENGTH_LIMIT),
            }
          }
        }
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (e: any) {
        cuckoo.error(cuckooEvents.GENERAL_ERROR_UTM_LOCAL_STORAGE_LOAD, { error: String(e) })
      }
      return acc
    }, {})
  }
  return {}
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function saveToSession(cuckoo: any, object: UtmSet): void {
  if (HAS_LOCAL_STORAGE) {
    Object.keys(object)
      // @ts-expect-error: Flow to TS migration.
      .filter((key) => UTM_LIST.includes(key))
      .forEach((key) => {
        try {
          setItem(
            key,
            JSON.stringify({
              // @ts-expect-error: Flow to TS migration.
              value: object[key]?.substring(0, UTM_VALUE_LENGTH_LIMIT),
              createdAt: new Date(),
            }),
          )
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e: any) {
          cuckoo.error(cuckooEvents.GENERAL_ERROR_UTM_LOCAL_STORAGE_SET, { error: String(e) })
        }
      })
  }
}
